export enum MODALS {
  addContact = 'addContact',
  addInvoice = 'addInvoice',
  viewInvoice = 'viewInvoice',
  addCustomfields = 'addCustomfields',
  invoicesForContact = 'invoicesForContact',
  cancelPayments = 'cancelPayments',
  refundPayments = 'refundPayments',
  paymentsForInvoice = 'paymentsForInvoice',
  invoicesForPayment = 'invoicesForPayment',
  editPayment = 'editPayment',
  deleteContacts = 'deleteContacts',
  editContacts = 'editContacts',
  editInvoice = 'editInvoice',
  makePayment = 'makePayment',
  makeUserPayment = 'makeUserPayment',
  guessPayment = 'guessPayment',
  mergeContacts = 'mergeContacts',
  addCreditCard = 'addCreditCard',
  addUserCreditCard = 'addUserCreditCard',
  editCreditCard = 'editCreditCard',
  addBankAccount = 'addBankAccount',
  editBankAccount = 'editBankAccount',
  manageCustomFields = 'manageCustomFields',
  manageGroups = 'manageGroups',
  manageRelations = 'manageRelations',
  managePreset = 'managePreset',
  manageAccounts = 'manageAccounts',
  manageDepartments = 'manageDepartments',
  managePrograms = 'managePrograms',
  manageProducts = 'manageProducts',
  manageUserAdmins = 'manageUserAdmins',
  manageTeams = 'manageTeams',
  uploadImage = 'uploadImage',
  chooseOrganisation = 'chooseOrganisation',
  userDonation = 'userDonation',
  adminDonation = 'adminDonation',
  changeEmail = 'changeEmail',
  changePassword = 'changePassword',
  paymentsForContact = 'paymentsForContact',
  ticketIdentifiers = 'ticketIdentifiers',
  addEvent = 'addEvent',
  editFundraising = 'editFundraising',
  editUserPayment = 'editUserPayment',
  editUserCreditCard = 'editUserCreditCard',
  shortcutsList = 'shortcutsList',
  addAmbassador = 'addAmbassador',
  editAmbassador = 'editAmbassador',
  editTransaction = 'editTransaction',
  editTicket = 'editTicket',
  addTicket = 'addTicket',
  addRecurring = 'addRecurring',
  editRecurring = 'editRecurring',
}

export type ModalModel = {
  [modal in MODALS]: {
    opened: boolean,
    payload: any,
  }
};

export interface ModalPayload {
  modal: MODALS,
}
